<script lang="ts">
	import { Theme } from '$lib/components/theme'
	import { TextEditor } from '@repo/ui'
	import type { SettingsV1AffiliateRegistrationCustomization } from '@sdk/Api'
	import { currentTheme } from '@store/theme'

	interface Props {
		customization: SettingsV1AffiliateRegistrationCustomization | null
	}

	let { customization }: Props = $props()

	const topBannerUrl = $derived(
		($currentTheme === Theme.light
			? customization?.lightModeTopBannerUrl
			: customization?.darkModeTopBannerUrl) || '/background/icons-bg-top.svg',
	)

	const bottomBannerUrl = $derived(
		($currentTheme === Theme.light
			? customization?.lightModeBottomBannerUrl
			: customization?.darkModeBottomBannerUrl) || '/background/icons-bg-bottom.svg',
	)
</script>

<div
	style="background-image: url({topBannerUrl}), url({bottomBannerUrl})"
	class="background md:dark:bg-primary-950/30 md:bg-primary-50 flex w-full items-center bg-white md:h-full"
>
	{#if customization?.pageNote}
		<div class="m-auto flex max-w-3xl items-center md:p-10">
			<div
				class="dark:border-primary-600 border-primary-400 mt-2 rounded-md border-1 bg-white p-5 md:my-7 dark:bg-gray-800"
			>
				<TextEditor
					name="registration-note"
					additionalClasses="prose max-w-none dark:prose-invert"
					content={customization.pageNote}
					readonly
				/>
			</div>
		</div>
	{/if}
</div>

<style>
	@media screen and (min-width: 768px) {
		.background {
			background-position:
				top left,
				bottom left;
			background-repeat: no-repeat;
			background-size: contain;
		}
	}
</style>
